import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { FormEvent, useState } from "react";
import { SEOHead } from "@/components/shared/SEOHead";
import { createBusinessPortalSession } from "@/lib/b2bPortalApi";

export const Route = createFileRoute("/business/portal/login")({
  component: BusinessPortalLoginPage,
});

function BusinessPortalLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await createBusinessPortalSession(username, password);
      await navigate({ to: "/business/portal" });
    } catch {
      setError("Username or password was not recognized.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="page-enter b2b-portal-page b2b-login-page">
      <SEOHead title="Business Portal Sign In" description="Sign in to your Quuil business packaging portal." path="/business/portal/login" robots="noindex,follow" />
      <section className="b2b-login-shell">
        <form className="b2b-login-card" onSubmit={handleSubmit}>
          <Link to="/business" className="b2b-portal-brand">
            <span className="b2b-portal-mark">Q</span>
            <span>
              <strong>Quuil Business</strong>
              <small>Packaging portal</small>
            </span>
          </Link>

          <div>
            <span className="b2b-kicker">Business sign in</span>
            <h1>Open your workspace</h1>
            <p>Use the username and password Quuil issued for your business account.</p>
          </div>

          <label className="b2b-login-field">
            <span>Username</span>
            <input
              autoComplete="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              placeholder="username"
            />
          </label>

          <label className="b2b-login-field">
            <span>Password</span>
            <input
              autoComplete="current-password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="password"
            />
          </label>

          {error ? <p className="b2b-login-error">{error}</p> : null}

          <button type="submit" className="b2b-primary-button" disabled={submitting}>
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </section>
    </main>
  );
}
